// src/components/sections/About/AboutStats.jsx
import React from 'react';
import { Trophy, Users, Coffee, Star } from 'lucide-react';
import { useExperience } from '../../../context/ExperienceContext';

const AboutStats = () => {
  const { yearsOfExperience } = useExperience();

  const stats = [
    {
      icon: Trophy,
      value: yearsOfExperience.displayText,
      label: 'Years Experience',
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-100 dark:bg-yellow-900/30'
    },
    {
      icon: Users,
      value: '1',
      label: 'Company Founded',
      color: 'text-blue-500',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30'
    },
    {
      icon: Star,
      value: '20+',
      label: 'Projects Completed',
      color: 'text-purple-500',
      bgColor: 'bg-purple-100 dark:bg-purple-900/30'
    },
    {
      icon: Coffee,
      value: '∞',
      label: 'Cups of Coffee',
      color: 'text-orange-500',
      bgColor: 'bg-orange-100 dark:bg-orange-900/30'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
      {stats.map((stat, index) => (
        <div 
          key={index}
          className="text-center group hover:scale-105 transition-transform duration-300"
        >
          <div className={`${stat.bgColor} w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:shadow-lg transition-shadow`}>
            <stat.icon className={`w-8 h-8 ${stat.color}`} />
          </div>
          <div className="text-3xl font-bold text-gray-900 dark:text-white mb-1">
            {stat.value}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-300">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AboutStats;